import { PropsWithChildren, useMemo } from 'react';
import { Tooltip } from '@ds';
import { BaseViolationItem } from '@lp/features/Scheduler/types';
import { toLocalDateFromApiDateKey } from '@lp/features/Scheduler/utils';
import { formatDate } from '@/utils/helpers';

const renderItemMessages = (messages: string[]) => {
  return messages.length === 1 ? (
    <span className="text-xs-r text-base-20">{messages[0]}</span>
  ) : (
    <ul className="flex flex-col gap-1 list-outside list-disc ms-3">
      {messages.map((msg, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index} className="text-xs-r text-base-20">
          {msg}
        </li>
      ))}
    </ul>
  );
};

type ScheduleViolationTooltipProps = PropsWithChildren<{
  items: BaseViolationItem | BaseViolationItem[];
  placement?: 'right' | 'bottom';
  withLabel?: boolean;
}>;

export const ScheduleViolationTooltip = ({
  items,
  placement = 'right',
  withLabel = false,
  children,
}: ScheduleViolationTooltipProps) => {
  const tooltipContent = useMemo(() => {
    return (
      <div className="flex flex-col gap-1.5">
        <div className="text-xs-m text-danger-40">Warning:</div>
        <div className="flex flex-col gap-2">
          {withLabel
            ? (Array.isArray(items) ? items : [items]).map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={index} className="flex flex-col gap-0.5">
                  {item.day && (
                    <span className="text-xs-m text-base-10">
                      {formatDate(toLocalDateFromApiDateKey(item.day), 'MM/dd/yyyy')}
                    </span>
                  )}
                  {renderItemMessages(item.messages)}
                </div>
              ))
            : renderItemMessages(Array.isArray(items) ? items.flatMap((item) => item.messages) : items.messages)}
        </div>
      </div>
    );
  }, [items, withLabel]);

  return (
    <Tooltip
      placement={placement}
      content={tooltipContent}
      className="max-w-[176px] border border-danger-40 px-2.5 py-2"
    >
      {children}
    </Tooltip>
  );
};
